import { ACCOUNT_TYPE, fetchUserData, selectUserData } from '../accountSlice'
import EditInvoiceRecipientsPopup from './EditInvoiceRecipientsPopup'
import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import useUserFetch from '../hooks/useUserFetch'
import usePopupState from 'hooks/usePopupState'
import { RecipientsList } from './Recipients'
import { useEffect, useRef } from 'react'
import { STATUS } from 'utils/constants'
import './style.scss'

const type = ACCOUNT_TYPE.invoiceRecipients
const POPUP_TYPE = 'editInvoiceRecipients'

/**
 * Podgląd „Faktury trafią do” w kroku danych do faktury (checkout).
 * Bez companyId — ustawienia prywatne klienta.
 */
const Content = ({ companyId }) => {
  const { data, status } = useSelector(state => selectUserData(state, type))
  useUserFetch(type)

  const { popup, openPopup } = usePopupState()
  const { t } = useTranslation('account.invoiceRecipients')
  const dispatch = useDispatch()

  const settings = companyId
    ? data?.companies?.find(({ id }) => id === companyId)
    : data?.personal

  // firma dodana przed chwilą nie ma jeszcze ustawień w store — pobieramy raz na firmę
  const refetchedFor = useRef(null)
  useEffect(() => {
    if (!companyId || settings || status !== STATUS.succeed) return
    if (refetchedFor.current === companyId) return
    refetchedFor.current = companyId
    dispatch(fetchUserData(type))
  }, [companyId, dispatch, settings, status])

  if (!settings) return null

  const recipients = Array.isArray(settings.recipients) ? settings.recipients : []
  const canEdit = settings.canEdit !== false
  const hasExtraEmails = Array.isArray(settings.invoiceEmails) && settings.invoiceEmails.length > 0
  const open = () => openPopup({ type: POPUP_TYPE, props: { companyId } })

  return (
    <>
      {popup?.type === POPUP_TYPE && <EditInvoiceRecipientsPopup companyId={popup?.props?.companyId} />}

      {/* bez dodatkowych adresów — sam przycisk dodania; z adresami (lub bez prawa edycji) — pełny podgląd */}
      {canEdit && !hasExtraEmails
        ? <button
          type='button'
          className='invoiceRecipients__checkoutAdd'
          onClick={open}>
          <span className='invoiceRecipients__plus' aria-hidden='true'>+</span>
          <span>{t('addInvoiceEmail')}</span>
        </button>
        : <div className='invoiceRecipients__checkout'>
          <div className='invoiceRecipients__checkoutHead'>
            <span>{t('sendTo')}</span>
            {canEdit && <button
              type='button'
              className='invoiceRecipients__link'
              onClick={open}>
              {t('change')}
            </button>}
          </div>

          <div className='invoiceRecipients__preview'>
            <RecipientsList recipients={recipients} />
          </div>

          {!canEdit && <div className='invoiceRecipients__hint --left'>{t('readOnly')}</div>}
        </div>}
    </>
  )
}

const CheckoutRecipients = ({ companyId }) => {
  const isLogin = useSelector(selectIsLoggedIn)
  return isLogin ? <Content companyId={companyId} /> : null
}

export default CheckoutRecipients
